export default "<div class=\"typeacces\">\n  {{ TypeEvacuationInComponent?.Identifiant }}\n</div>\n";